import backofficeApi from "@others/backofficeApi.ts"

import { AppFunctions } from "@others/AppFunctions.ts"
import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { ExtEndpoints } from "@constants/ExtEndpoints.ts"
import { ConversationAiControlAdapter } from "@adapters/ConversationAiControlAdapter.ts"
import { IConversationAiControlStateApi } from "@interfaces/IConversationAiControlStateApi.ts"
import { IConversationAiControlStateCli } from "@interfaces/IConversationAiControlStateCli.ts"
import { IPutConversationAiControlBodyApi } from "@interfaces/IPutConversationAiControlBodyApi.ts"

const updateConversationAiControl = async (
	body: IPutConversationAiControlBodyApi
): Promise<IConversationAiControlStateCli> => {
	return backofficeApi
		.put<IApiResponse<IConversationAiControlStateApi>>(
			ExtEndpoints.backofficeChatAiControl,
			body
		)
		.then(({ data }) => ConversationAiControlAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

export default {
	updateConversationAiControl,
}
